module.exports = __webpack_public_path__ + "static/meteor-143aafd5ca4395c30a784601ac608fdb.jpg";